import * as React from "react";
import Spinner from "react-bootstrap/Spinner";

export const LoadingSpinner: React.FC = props => {
    return <Spinner animation="border" variant="primary" className="mt-3" />
}